import React from 'react';
import {asyncComponent} from 'react-async-component';

export const AsyncSiteHeader = asyncComponent({
    resolve: () => import(
        /* webpackChunkName: "header" */
        /* webpackPreload: true */
        './SiteHeader'
    ),
    LoadingComponent: () => <div className="site-header__placeholder"/>,
    serverMode: 'defer'
});
